import React from 'react';

import styles from './Ruler.module.scss';

type RulerProps = {
  /** 'MAIN' | 'SUB' | 'STEEL' | 'LIGHT_STEEL' | 'PLAYOFF_LEADER' | 'PLAYOFF_WILDCARD' | 'PLAYOFF_HUNT' */
  className?: string;
  marginStyle?: string;
  zeroMargin?: boolean;
} & Pick<React.HTMLProps<HTMLHRElement>, 'style' | 'onClick'>;

const Ruler: React.FC<RulerProps> = ({ className = 'SUB', zeroMargin = false, marginStyle = '', style, ...props }) => {
  const zeroMarginCls = zeroMargin ? styles.ZeroMargin : '';
  const baseCls = `${styles.RulerContainer} ${className} ${zeroMarginCls} ${marginStyle}`;

  return <hr style={style} className={baseCls} onClick={props.onClick} />;
};

export default Ruler;
